!function (e, n) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = n();else if ("function" == typeof define && define.amd) define([], n);else {
    var t = n();

    for (var r in t) {
      ("object" == typeof exports ? exports : e)[r] = t[r];
    }
  }
}(this, function () {
  return function (e) {
    var n = {};

    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) {
        t.d(r, o, function (n) {
          return e[n];
        }.bind(null, o));
      }
      return r;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 4);
  }({
    4: function _(e, n, t) {
      "use strict";

      t.r(n), t.d(n, "ULTRA_LIGHT", function () {
        return r;
      }), t.d(n, "REGULAR", function () {
        return o;
      }), t.d(n, "MEDIUM", function () {
        return u;
      }), t.d(n, "SEMIBOLD", function () {
        return i;
      }), t.d(n, "BOLD", function () {
        return f;
      }), t.d(n, "TABLET", function () {
        return c;
      }), t.d(n, "DESKTOP", function () {
        return a;
      }), t.d(n, "MONO", function () {
        return l;
      }), t.d(n, "SANS", function () {
        return d;
      });
      var r = 200,
          o = 400,
          u = 500,
          i = 600,
          f = 700,
          c = 768,
          a = 1200,
          l = "'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace",
          d = "'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif";
    }
  });
});